document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.getElementById('wa-toggle');
  const popup = document.getElementById('wa-popup');
  const close = document.getElementById('wa-close');
  const bubble = document.getElementById('wa-bubble');

  if (!toggle || !popup || !close) return;

  setTimeout(function () {
    if (bubble && !localStorage.getItem('wa_closed')) {
      bubble.classList.add('show');
    }
  }, 2500);

  toggle.addEventListener('click', function () {
    popup.classList.toggle('active');
    if (bubble) bubble.classList.remove('show');
  });

  close.addEventListener('click', function () {
    popup.classList.remove('active');
    localStorage.setItem('wa_closed', '1');
  });
});